import Route from '@ember/routing/route';

export default class MobileHomeIndexRoute extends Route {}
